import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-forest-green to-sage-green text-white">
      <div className="container">
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="bg-white rounded-2xl p-3 shadow-lg">
                <div className="h-16 w-16 overflow-hidden flex items-center justify-center">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_counseling-center-4/artifacts/5b6tpl6s_KAVI%CC%87%20PSI%CC%87KOLOJI%CC%87%20%281%29.png"
                    alt="Kavi Psikoloji"
                    className="w-auto h-auto scale-[2.8] origin-center"
                  />
                </div>
              </div>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              Profesyonel ve güvenilir psikolojik danışmanlık hizmetleri ile yanınızdayız. Bireysel, aile ve çift terapisi alanlarında uzman kadromuzla size destek olmak için buradayız.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <span className="w-1.5 h-1.5 bg-mint-green rounded-full mr-2 group-hover:scale-125 transition-transform"></span>
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <span className="w-1.5 h-1.5 bg-mint-green rounded-full mr-2 group-hover:scale-125 transition-transform"></span>
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <span className="w-1.5 h-1.5 bg-mint-green rounded-full mr-2 group-hover:scale-125 transition-transform"></span>
                  Hizmetlerimiz
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <span className="w-1.5 h-1.5 bg-mint-green rounded-full mr-2 group-hover:scale-125 transition-transform"></span>
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">İletişim Bilgileri</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <Phone className="w-5 h-5 text-mint-green mt-0.5 flex-shrink-0" />
                <a href="tel:+905305128090" className="text-white/80 hover:text-white transition-colors">
                  0530 512 80 90
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Mail className="w-5 h-5 text-mint-green mt-0.5 flex-shrink-0" />
                <a href="mailto:info@kavipsikoloji.com" className="text-white/80 hover:text-white transition-colors">
                  info@kavipsikoloji.com
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <MapPin className="w-5 h-5 text-mint-green mt-0.5 flex-shrink-0" />
                <span className="text-white/80">
                  Birlik Mahallesi 488. Sokak 8/A Çankaya/ANKARA
                </span>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Çalışma Saatleri</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 text-sm">
                <Clock className="w-5 h-5 text-mint-green mt-0.5 flex-shrink-0" />
                <div className="text-white/80">
                  <p>Pazartesi - Cumartesi: 09:00 - 19:00</p>
                  <p>Pazar: Kapalı</p>
                </div>
              </div>
            </div>
            <div className="pt-4">
              <p className="text-sm font-medium mb-3">Bizi Takip Edin</p>
              <a 
                href="https://www.instagram.com/kavi_psikoloji" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-white/20 hover:bg-white/30 transition-all hover:scale-105 group"
              >
                <Instagram className="w-5 h-5" />
                <span className="text-sm font-medium">@kavi_psikoloji</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <p className="text-white/70 text-sm text-center md:text-left">
              © 2024 Kavi Psikolojik Danışmanlık Merkezi. Tüm hakları saklıdır.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-white/70 hover:text-white transition-colors">Gizlilik Politikası</a>
              <a href="#" className="text-white/70 hover:text-white transition-colors">Kullanım Koşulları</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};